export enum PlatformApplicationSubTab {
  ALL = 'all',
  INCOMPLETE = 'incomplete',
  IN_PROGRESS = 'in-progress',
  PROCESS_ENDED = 'process-ended',
}
